<template>
	<div>
		<div class="text-center list-title">
			Реестр взаимодействия
		</div>
		<div class='l-header-wrapper'>
			<table class='header'>
				<thead>
					<tr>
						<th class='center l-td'>ФО</th>
						<th class='center l-td'>Субъект РФ</th>
						<th class='center l-td'>Лесничество</th>
						<th class='center l-td'>Номера актов</th>
						<th class='center l-td'>Надзорный орган</th>
						<th class='center l-td'>Дата</th>
						<th class='center l-td'>Номер</th>
						<th class="l-scroll"></th>
					</tr>
					<tr>
						<th class='l-td'><filter-table field='fo' :filter='filter' :wideWindow='true' :suffix='journalSuffix'/></th>
						<th class='l-td'><filter-table field='region' :filter='filter' :wideWindow='true' :suffix='journalSuffix'/></th>
						<th class='l-td'><filter-table field='forestry' :filter='filter' :wideWindow='true' :suffix='journalSuffix'/></th>
						<th class='l-td'><filter-table field='act_nums' :filter='filter' :wideWindow='true' :suffix='journalSuffix'/></th>
						<th class='l-td'><filter-table field='supervisory' :filter='filter' :wideWindow='true' :suffix='journalSuffix'/></th>
						<th class='l-td'><filter-table field='letter_date_txt' :filter='filter' :wideWindow='true' :suffix='journalSuffix'/></th>
						<th class='l-td'><filter-table field='letter_num' :filter='filter' :wideWindow='true' :suffix='journalSuffix'/></th>
						<th class="l-scroll" @click='clearFilters'><span class="glyphicon glyphicon-remove pointer" title="Сбросить фильтры"></span></th>
					</tr>
				</thead>
			</table>
		</div>
		<div class='l-body-wrapper'>
			<table class='body'>
				<tbody>
					<tr v-for='(line, i) in lines' @click='select_line(i)' :class='{ selected: line.selected }'>
						<td class='td-num l-td'>{{line.fo}}</td>
						<td class='td-num l-td'>{{line.region}}</td>
						<td class='td-num l-td'>{{line.forestry}}</td>
						<td class='td-num l-td'>{{line.act_nums}}</td>
						<td class='td-num l-td'>{{line.supervisory}}</td>
						<td class='td-num l-td'>{{line.letter_date_txt}}</td>
						<td class='td-num l-td'>{{line.letter_num}}</td>
					</tr>
				</tbody>
			</table>
		</div>

	<div>
		<!-- <div v-if='can_change' class="pull-left change-conclusion-user-button">
			<button type="button" class="btn btn-primary" @click='showChangeConclusionUser' v-if='lines.length'>Назначить ответственного</button>
		</div> -->
		<div class="text-center">
			<ul class="pagination" v-if='pages'>
				<li :class='{ active: page.active }' v-for='page in pages'>
					<a v-if='isNumeric(page.num)' href='#' @click='select_page' :data-value='page.num'>{{page.num}}</a>
					<span v-else href='#' class="disabled_page">{{page.num}}</span>
				</li>
			</ul>
		</div>
	</div>

	<modal v-model="showChangeConclusionUserValue" :backdrop='false' medium>
		<div slot="modal-header" class="modal-header">
		    <h4 class="modal-title">
		      <b>Назначить ответственного за заключения</b>
		    </h4>
		  </div>
		<div style="margin-bottom: 15px">
			<ul class="user-list">
				<li v-for='user in users'>
					<input type="radio" :id='user.id' v-model="conclusion_user" :value='user.id'>
					<label :for='user.id'>{{user.name}}</label>
				</li>
			</ul>
		</div>
		<div slot="modal-footer" class="modal-footer">
			<button type="button" class="btn btn-default" @click='closeChangeConclusionUser'>Отмена</button>				
			<button type="button" class="btn btn-primary" @click='changeConclusionUser' :disabled='!conclusion_user'>Ок</button>
		</div>
	</modal>
</div>
</template>

<script>
import {DB} from './../constants'
import {ROWS_ON_PAGE} from './../constants'
	const USERS = 'get_users.php'
	const CAN_CHANGE_CONCLUSION_USER = 'can_change_conclusion_user.php'
	const CHANGE_CONCLUSION_USER = 'change_conclusion_user.php'
	const TABLE = 'get_journal_supervisory.php'
	const FILTER_TABLE = 'get_journal_supervisory.php'
	const COUNT_OF_FILTERS = 6
	const PADDING = 3
	import { EventBus } from '../lib/EventBus'

	import filterTable from './Filter'
	import moment from 'moment'
	import { modal } from 'vue-strap'

	export default {
		name: 'ListSupervisory',
		data () {
			return {
				lines: [],
				selected: 0,
				pages: [],
				active: 1,
				pages_count: 1,
				cf_count: 0,
				total_count: null,
				can_change: false,

				filter: {
					fo: [],
					region: [],
					act_nums: [],
					supervisory: [],
					letter_date_txt: [],
					letter_num: [],
				},

				users: [],
				conclusion_user: null,
				showChangeConclusionUserValue: false,

				journalSuffix: '-supervisory'
			}
		},
		components: {
			filterTable, modal
		},
		methods: {
			isNumeric (x) {
				return !Number.isNaN(+x)
			},
			getNumEnding (iNumber, aEndings)
			{
			    var sEnding, i;
			    iNumber = iNumber % 100;
			    if (iNumber>=11 && iNumber<=19) {
			        sEnding=aEndings[2];
			    }
			    else {
			        i = iNumber % 10;
			        switch (i)
			        {
			            case (1): sEnding = aEndings[0]; break;
			            case (2):
			            case (3):
			            case (4): sEnding = aEndings[1]; break;
			            default: sEnding = aEndings[2];
			        }
			    }
			    return sEnding;
			},
			showChangeConclusionUser () {
				this.conclusion_user = null
				this.showChangeConclusionUserValue = true
			},
			closeChangeConclusionUser () {
				document.querySelector('.user-list').scrollTop = 0
				this.showChangeConclusionUserValue = false
			},
			changeConclusionUser () {
				const arr_endings = ['заключения', 'заключений', 'заключений']
				const change = confirm('Вы уверены, что хотите назначить ответственного для ' + this.total_count + ' ' + this.getNumEnding(this.total_count, arr_endings) + '?')
				if(!change)
					return false

				let where = '('
				for (let f in this.filter) {
					for (let i = 0; i < this.filter[f].length; i++) {
						let field_name = f
						field_name = field_name.replace(this.journalSuffix, '') 
						where += this.filter[f][i] !== '' ? `${field_name}='${this.filter[f][i]}' or ` : `${field_name} is null or `	
					}
					
					where = this.filter[f].length !== 0 ? where.slice(0,-4) : where
					where += this.filter[f].length !== 0 ? ') and (' : ''
				}
				where = where.slice(0,-6)
				
				fetch(DB + CHANGE_CONCLUSION_USER + '?filter=' + where + '&user_id=' + this.conclusion_user, 
					{credentials: 'include'})
				.then(res => res.json())
				.then(res => {
					//console.warn(this.active)
					this.fetch_lines((this.active - 1) * ROWS_ON_PAGE + 1)
				})

				this.conclusion_user = null
				document.querySelector('.user-list').scrollTop = 0
				this.showChangeConclusionUserValue = false
			},
			select_line (i) {
				if (!this.lines[i].flag) {
					let k = i
					while (!this.lines[k].flag) {
						k--
					}

					i = k
				}

				this.selected = i

				for (let j = 0; j < this.lines.length; j++) {
					if (this.lines[j].flag) {
						this.lines[j].selected = (i === j)
					}
					else {
						let k = j
						while (!this.lines[k].flag) {
							k--
						}
						for (let l = 0; l < this.lines[k].count; l++) {
							this.lines[j].selected = (i === k)
						}
					}
				}

				// console.log('line: ');
				// console.log(this.lines[i]);

				EventBus.$emit('supervisory_id', this.lines[i])

				// document.getElementById(i).checked = true
				//EventBus.$emit('can_edit', {act: this.lines[i].can_edit_act, conclusion: this.lines[i].can_edit_conclusion, warrant: this.lines[i].can_edit_warrant})
			},
			fetch_lines (start) {
				//console.log('fetch_lines');
				let temp_lines = []
				let temp_pages = []

				let where = '('
				for (let f in this.filter) {
					for (let i = 0; i < this.filter[f].length; i++) {
						let field_name = f
						field_name = field_name.replace(this.journalSuffix, '') 
						where += this.filter[f][i] !== '' ? `${field_name}='${this.filter[f][i]}' or ` : `${field_name} is null or `	
					}
					
					where = this.filter[f].length !== 0 ? where.slice(0,-4) : where
					where += this.filter[f].length !== 0 ? ') and (' : ''
				}
				where = where.slice(0,-6)
				if(where)
					where = '&filter=' + where

				fetch(DB + FILTER_TABLE + `?start=${start}&rows=${ROWS_ON_PAGE}${where}`, {
					// fetch(DB + TABLE, {
						credentials: 'include'
					})
					.then(res => res.json())
					.then(res =>{
						let prev_id = -1
						let prev_localforestry_id = -1
						let prev_subforestry_id = -1

						if(res[res.length - 1].count)
								this.total_count = res[res.length - 1].count

						for (let i = 0; i < res.length - 1; i++) {

							let act = {}

							let start_fo = i
							while (i > 0 && res[start_fo - 1].act_id === res[i].act_id && start_fo > 1) {
								start_fo--
							}

							let curr = start_fo
							while (curr < res.length && res[curr].act_id === res[start_fo].act_id ) {
								curr++
							}
							act.count = curr - start_fo

							if (res[i].act_id === prev_id) {
								act.flag = false
							}
							else {
								act.flag = true
							}
							//////////////////

							let start_lf = i
							while (i > 0 && res[start_lf - 1].localforestry_id === res[i].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[i].act_id) {
								start_lf--
							}

							let curr_lf = start_lf
							while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[i].localforestry_id) {
								curr_lf++
							}
							act.count_lf = curr_lf - start_lf

							if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
								act.flag_lf = false
							}
							else {
								act.flag_lf = true
							}

							////////////////////////
							let start_sf = i
							while (i > 0 && res[start_sf - 1].localforestry_id === res[i].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[i].act_id) {
								start_sf--
							}

							let curr_sf = start_sf
							while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[i].localforestry_id) {
								curr_sf++
							}
							act.count_sf = curr_sf - start_sf

							if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
								act.flag_sf = false
							}
							else {
								act.flag_sf = true
							}
							////////////////////////
							

							prev_id = res[i].supervisory_id

							act.id = res[i].supervisory_id;
							act.supervisory_id = res[i].supervisory_id;

							act.fo = res[i].fo
							act.fo_id = res[i].fo_id;
							act.region = res[i].region
							act.region_id = res[i].region_id;
							act.forestry = res[i].forestry
							act.forestry_id = res[i].forestry_id

							act.act_nums = res[i].act_nums;
							act.supervisory = res[i].supervisory;
							act.letter_num = res[i].letter_num;
							act.letter_date_txt = res[i].letter_date_txt;
							//act.localforestry = res[i].localforestry
							//act.subforestry = res[i].subforestry
							//act.area = res[i].area
							//act.section = res[i].section
							//act.section_lp = res[i].section_lp
							act.selected = false

							temp_lines.push(act)
						}


						this.lines = temp_lines

						temp_lines = []

						// this.pages = temp_pages

						this.lines[0].selected = true

						if (this.lines[1] && !this.lines[1].flag) {
							let k = 1
							while (!this.lines[k].flag) {
								this.lines[k].selected = true
								k++
							}
						}

						EventBus.$emit('act_id', this.lines[0].id)
					})
					.catch(err => console.log(err))
				},
				select_page (e) {
					let value = +e.target.getAttribute('data-value')
					this.fetch_lines((value - 1) * ROWS_ON_PAGE + 1)
					this.active = value
					let temp_pages = []

					if(this.active - 1 > PADDING)
					{
						temp_pages.push({active: false, num: 1})
						temp_pages.push({active: false, num: '...'})
					}

					for (let i = this.active - PADDING - 1; i < this.active + PADDING; i++)
						if(i >= 0 && i < this.pages_count)
							temp_pages.push({active: false, num: i + 1})

					if(this.active < this.pages_count - PADDING)
					{
						temp_pages.push({active: false, num: '...'})
						temp_pages.push({active: false, num: this.pages_count})
					}

					this.pages = temp_pages

					this.pages.forEach(p => {
						p.active = (p.num == this.active)
					})

					//this.pages[value - 1].active = true
				},
				clearFilters () {
					this.cf_count = 0
					EventBus.$emit('clearFilters' + this.journalSuffix)
				},
				filter_lines () {
					//console.log('filter_lines');
					let temp_lines = []
					let temp_pages = []

					let where = '('
					for (let f in this.filter) {
						for (let i = 0; i < this.filter[f].length; i++) {
							let field_name = f
							field_name = field_name.replace(this.journalSuffix, '') 
							where += this.filter[f][i] !== '' ? `${field_name}='${this.filter[f][i]}' or ` : `${field_name} is null or `	
						}
						
						where = this.filter[f].length !== 0 ? where.slice(0,-4) : where
						where += this.filter[f].length !== 0 ? ') and (' : ''
					}
					where = where.slice(0,-6)

					//console.log('where');
					//console.log(where);

					let start = 1

					if (this.$route.params.id  || this.$parent.act_id) {
						start = (this.page_num - 1) * ROWS_ON_PAGE + 1
						this.active = this.page_num
					}

					let t = TABLE + `?start=${start}&rows=${ROWS_ON_PAGE}`
					if (where) {
						t = FILTER_TABLE + `?start=${start}&rows=${ROWS_ON_PAGE}&filter=${where}`
					}

					fetch(DB + t, {
						credentials: 'include'
					})
					.then(res => res.json())
					.then(res =>{
						let prev_id = -1
						let prev_localforestry_id = -1
						let prev_subforestry_id = -1

						let length = (!!where) ? res.length : res.length - 1

						if(res[res.length - 1].count)
								this.total_count = res[res.length - 1].count

						for (let i = 0; i < length; i++) {
							let act = {}

							let start_fo = i
							while (i > 0 && res[start_fo - 1].act_id === res[i].act_id && start_fo > 1) {
								start_fo--
							}

							let curr = start_fo
							while (curr < res.length && res[curr].act_id === res[start_fo].act_id ) {
								curr++
							}
							act.count = curr - start_fo

							if (res[i].act_id === prev_id) {
								act.flag = false
							}
							else {
								act.flag = true
							}
							//////////////////

							let start_lf = i
							while (i > 0 && res[start_lf - 1].localforestry_id === res[i].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[i].act_id) {
								start_lf--
							}

							let curr_lf = start_lf
							while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[i].localforestry_id) {
								curr_lf++
							}
							act.count_lf = curr_lf - start_lf

							if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
								act.flag_lf = false
							}
							else {
								act.flag_lf = true
							}

							////////////////////////
							let start_sf = i
							while (i > 0 && res[start_sf - 1].localforestry_id === res[i].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[i].act_id) {
								start_sf--
							}

							let curr_sf = start_sf
							while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[i].localforestry_id) {
								curr_sf++
							}
							act.count_sf = curr_sf - start_sf

							if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
								act.flag_sf = false
							}
							else {
								act.flag_sf = true
							}
							////////////////////////
							

							prev_id = res[i].supervisory_id

							act.id = res[i].supervisory_id;
							act.supervisory_id = res[i].supervisory_id;

							act.fo = res[i].fo
							act.fo_id = res[i].fo_id;
							act.region = res[i].region
							act.region_id = res[i].region_id;
							act.forestry = res[i].forestry
							act.forestry_id = res[i].forestry_id

							act.act_nums = res[i].act_nums;
							act.supervisory = res[i].supervisory;
							act.letter_num = res[i].letter_num;
							act.letter_date_txt = res[i].letter_date_txt;

							//act.localforestry = res[i].localforestry
							//act.subforestry = res[i].subforestry
							//act.area = res[i].area
							////act.section = res[i].section
							//act.section_lp = res[i].section_lp
							act.selected = false
							
							temp_lines.push(act)
						}

						//if (!where) {
							//let count = Math.round(res[res.length - 1].count / ROWS_ON_PAGE)
							this.pages_count = Math.ceil(res[res.length - 1].count / ROWS_ON_PAGE)
							temp_pages = []

							if(this.active > PADDING)
							{
								temp_pages.push({active: false, num: 1})
								temp_pages.push({active: false, num: '...'})
							}

							
							for (let i = this.active - PADDING; i < this.active + PADDING; i++) {
								if(i >= 0 && i < this.pages_count)
									temp_pages.push({active: false, num: i + 1})
							}

							if(this.active < this.pages_count - PADDING)
							{
								temp_pages.push({active: false, num: '...'})
								temp_pages.push({active: false, num: this.pages_count})
							}

							this.pages = temp_pages
							this.pages.forEach(p => {
								p.active = (p.num == this.active)
							})
						//}

						this.lines = temp_lines

						if(this.$route.params.id || this.$parent.act_id) {
							let act_id = this.$route.params.id || this.$parent.act_id
							let found = false
							for (let i = 0; i < this.lines.length; i++) {
								if (this.lines[i].id == act_id) {
									this.select_line(i)
									
									this.$nextTick(() => {
										const selected_row = document.querySelector("tr.selected")
										if(selected_row)
											selected_row.scrollIntoView(true)
									})

									found = true
									break
								}
							}
							if(!found)
								this.select_line(0)
						}
						else {
							this.select_line(0)
						}
						
					})
					.catch(err => console.log(err))
				}

			},
			created () {

			},
			mounted () {
				this.$parent.lastJournalURL = '/main/supervisory'

				fetch(DB + USERS, {
						credentials: 'include'
					})
					.then(res => res.json())
					.then(res =>{
						this.users = res
					})

				fetch(DB + CAN_CHANGE_CONCLUSION_USER, {
						credentials: 'include'
					})
					.then(res => res.json())
					.then(res =>{
						this.can_change = (res[0].value == 't')
					})

				EventBus.$on('filter' + this.journalSuffix + '_list', f => {
					this.filter[f.field] = f.value !== '' ? f.value : null
					this.active = 1
					if(f.cf) //clearFilters
					{
						this.cf_count++
						if(this.cf_count == COUNT_OF_FILTERS)
							this.filter_lines()
					}
					else
						this.filter_lines()
				})

				this.page_num = this.$parent.page_num_supervisory ? this.$parent.page_num_supervisory : 1

				if(this.$parent.selected_filters) {
					for(let field in this.$parent.selected_filters) {
						if(field.includes(this.journalSuffix))
							this.filter[field] = this.$parent.selected_filters[field].value
					}
				}
				this.filter_lines()

				// const w = document.documentElement.clientWidth - 50
				// document.querySelector('.main_table_wrapper').style.width = `${w}px`

				////////////////////////////////////////////

				const dispay_width = document.documentElement.clientWidth
				// const dispay_height = document.documentElement.clientHeight - 146
				const dispay_height = document.documentElement.clientHeight - 208
				let scroll_width = 17

				const ua = navigator.userAgent

				if (ua.search('OPR/') > 0) {
					scroll_width = 15
				}

				const table_width = dispay_width - scroll_width
				const col_width = Math.floor(table_width / COUNT_OF_FILTERS)
				// 
				const large_width = table_width - (col_width * 9)

				// console.log(col_width, large_width, table_width, col_width * 9 + large_width)


				document.querySelectorAll('.l-td').forEach(td => {
					td.width = col_width
				})
				document.querySelectorAll('.large-td').forEach(td => {
					td.width = large_width
				})
				document.querySelector('.l-header-wrapper').width = dispay_width
				document.querySelector('.l-body-wrapper').width = dispay_width
				document.querySelector('.l-body-wrapper').style.maxHeight = `${dispay_height}px`

			// console.log(dispay_height, dispay_width, col_width, table_width)
			// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

				document.querySelector('.l-scroll').width = scroll_width
			},
			beforeDestroy() {
				//this.lines = []
				EventBus.$off('filter' + this.journalSuffix + '_list')
				//EventBus.$emit('save-filter-supervisory', {f: this.filter})
				EventBus.$emit('save-page' + this.journalSuffix, this.active)
			}
		}

		</script>

		<style>

		div.l-header-wrapper {
			border: 1px solid black;
			border-bottom: none;  
			/*width: 1634px;*/
		}

		div.l-body-wrapper {
			overflow-x: hidden;
			overflow-y: scroll;
			/*width: 1634px;*/
			/*max-height: 1200px;*/
			border: 1px solid black;
			border-top: none;
		}

		table.header {
			border-bottom: 1px solid black;
			width: 100%;
		}

		td.l-td,  th.l-td {
			vertical-align: middle; 
			word-break: break-all; 
			font-size: 12px;
		}

		td.large-td,  th.large-td {
			/*width: 214px;*/
			vertical-align: middle;  
		}

		table.body {
			width: 100%;
			table-layout: fixed;
		}

		.main_table tr, td, .main_table tr, th {
			text-align: center !important;
			border: 1px solid;
			border-collapse: collapse;
		}

		.td-url {
			word-break: break-all;
		}

		.td-num {
			max-width: 170px;
		}

		.main_table tr {
			height: 21px;
		}


	/* .radio_input {
		margin: 5px !important;
		} */

		th.center {
			text-align: center !important;
		}

		.selected {
			background-color: skyblue;
		}

		.disabled_page {
			cursor: default;
		}
		</style>

		<style scoped>
			.pagination {
				margin: 20px 0 4px 0;
			}

			.change-conclusion-user-button {
				margin-top: 20px;
				position: absolute;
			}

			.user-list {
				max-height: 400px;
			    overflow-y: auto;
			    list-style: none;
			    padding-left: 10px;
			}

			.user-list input[type="radio"] {
				position: relative;
				top: 2px;
			}
		</style>


// WEBPACK FOOTER //
// ListSupervisory.vue?f6035a28